export default "__VITE_ASSET__DLBXr_3N__";